import './SkeletonLoader.css';

export type SkeletonShape = 'text-line' | 'heading-line' | 'card-block' | 'table-row';

export function SkeletonLoader({
  shape = 'text-line',
  count = 1,
  width,
}: {
  shape?: SkeletonShape;
  count?: number;
  width?: string;
}) {
  return (
    <div className={`nx-skeleton nx-skeleton--${shape}`} style={{ width }} aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <span key={i} className="nx-skeleton__item" />
      ))}
    </div>
  );
}